import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubHeResearchInitiativeParticipateBoxLayoutParticipateItemCls: string;
			heHubHeResearchInitiativeParticipateBoxLayoutStepWrapperCls: string;
		}
	},

	slug: string
}

class Participate extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub He Research Initiative Participate Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeResearchInitiativeParticipateBoxLayoutParticipateItemCls || '', 'he_hub_he_research_initiative_participate', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeResearchInitiativeParticipateBoxLayoutStepWrapperCls || '', 'he_hub_he_research_initiative_participate', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Participate;